import React, { memo } from 'react';

import TextAvatar from '@components/common/TextAvatar';

import styles from './IconAvatar.module.scss';

interface IIconAvatarProps {
	id: string;
	size?: string;
	fontSize?: string;
	onClick?: () => void;
	isLogoSquare?: boolean;
}

const IconAvatar = ({
	id,
	size = '28px',
	fontSize = '10px',
	onClick,
	isLogoSquare,
}: IIconAvatarProps) => {
	return (
		<div
			className={styles.wrapper}
			onClick={onClick}
		>
			<TextAvatar
				avatarId={id}
				fontSize={fontSize}
				isLogoSquare={isLogoSquare}
				isProfileLogo
				size={size}
			/>
		</div>
	);
};

export default memo(IconAvatar);
